import React from "react";
import { Switch, Route } from "react-router-dom";
import PendingArtisansList from "./PendingArtisansList";
import ViewPendingArtisan from "./ViewPendingArtisan";

const artisans = () => (
	<Switch>
		<Route
			exact
			component={PendingArtisansList}
			path="/artisans-moderation/artisans"
		/>
		<Route
			exact
			component={ViewPendingArtisan}
			path="/artisans-moderation/artisans/:artisanId"
		/>
	</Switch>
);

export default artisans;
